import CommonResult from 'app/components/OrderPayment/Common/CommonResult';
import React from 'react';

const TossResult = () => {
  return <CommonResult />;
};

export default TossResult;
